import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import BreadCrum from '../../features/breadcrum/BreadCrum';
import {
    getChatsByUserId,
    getMessagesByChatId,
    activeMessagesUnsubscribe,
    markChatAsRead,
} from '../../redux/Chat/chatAction';
import Navbar from '../Navbar';
import ChatCards from './ChatCards';
import ChatDetails from './ChatDetails';
import './chat.css';
import Loading from '../../components/Loading';

const Chat = () => {
    const dispatch = useDispatch();
    const { userData } = useSelector((state) => state.user);
    const { isGettingChats, allChats } = useSelector((state) => state.chat);

    const [selectedChat, setSelectedChat] = useState(null);
    const [toggle, setToggle] = useState(false);
    const [chatMob, setChatMob] = useState(false);

    const chatRef = useRef(null);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const chatId = searchParams.get('chatId');
    const isBusinessUser = userData?.role === 'business';

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            if (activeMessagesUnsubscribe) {
                activeMessagesUnsubscribe();
            }
        };
    }, []);

    const chatOnClick = (chat) => {
        setSelectedChat(chat);
        dispatch(getMessagesByChatId(chat?.id, userData?.id));
        setChatMob(true);
    };

    const loadChatMessages = () => {
        if (!selectedChat?.id && allChats.length > 0) {
            if (chatId) {
                const foundChat = allChats.find(
                    (chatDetails) => chatDetails?.id === chatId
                );
                if (foundChat) {
                    chatOnClick(foundChat);
                } else if (window.innerWidth > 767.99) {
                    chatOnClick(allChats[0]);
                }
            } else if (window.innerWidth > 767.99) {
                chatOnClick(allChats[0]);
            }
        }
    };

    useEffect(() => {
        if (allChats.length > 0) {
            loadChatMessages();
        }
    }, [allChats, chatId]);

    // Clear unread count for the currently open chat
    useEffect(() => {
        if (selectedChat?.id && userData?.id) {
            const currentChatInRedux = allChats.find(
                (c) => c.id === selectedChat.id
            );
            if (currentChatInRedux && currentChatInRedux[userData.id] > 0) {
                dispatch(markChatAsRead(selectedChat.id, userData.id));
            }
        }
    }, [allChats, selectedChat, userData?.id, dispatch]);
    const breadcrumbItems = isBusinessUser
        ? [
              { title: 'Dashboard', path: '/dashboard' },
              { title: 'Messages', path: '/dashboard/chat' },
          ]
        : [
              {
                  title: 'Appointments',
                  path: '/customer/upcoming-appointments',
              },
              { title: 'My Messages', path: '/customer/chat' },
          ];

    return (
        <>
            {isGettingChats && !allChats.length ? (
                <Loading />
            ) : isBusinessUser ? (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 px-0 bg-ff br-top-left-22 min-h-100vh">
                            <div className="container-fluid">
                                <Navbar />
                            </div>
                            <div className="container-fluid px-4 px-md-5 pb-5">
                                <BreadCrum items={breadcrumbItems} />
                                <h1 className="chat-page-title">Messages</h1>
                                <div className="row d-flex">
                                    <div
                                        className={`col-12 d-md-block p-0 ${
                                            chatMob ? 'd-none' : 'd-block'
                                        } ${
                                            !toggle
                                                ? 'col-lg-3 col-md-4'
                                                : 'col-md-auto chat-sidebar-collapsed'
                                        }`}
                                    >
                                        <ChatCards
                                            toggle={toggle}
                                            setToggle={setToggle}
                                            chatOnClick={chatOnClick}
                                            selectedChat={selectedChat}
                                        />
                                    </div>
                                    <div
                                        className={`col-12 d-md-block p-0 ${
                                            chatMob ? 'd-block' : 'd-none'
                                        } ${
                                            !toggle
                                                ? 'col-lg-9 col-md-8'
                                                : 'col-md chat-sidebar-expanded'
                                        }`}
                                    >
                                        <ChatDetails
                                            selectedChat={selectedChat}
                                            setChatMob={setChatMob}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container px-4 px-md-5 pb-5 bg-white">
                    <BreadCrum items={breadcrumbItems} />
                    <h1 className="chat-page-title">Messages</h1>
                    <div className="row d-flex">
                        <div
                            className={`col-12 d-md-block p-0 ${
                                chatMob ? 'd-none' : 'd-block'
                            } ${
                                !toggle
                                    ? 'col-lg-3 col-md-4'
                                    : 'col-md-auto chat-sidebar-collapsed'
                            }`}
                        >
                            <ChatCards
                                toggle={toggle}
                                setToggle={setToggle}
                                chatOnClick={chatOnClick}
                                selectedChat={selectedChat}
                            />
                        </div>
                        <div
                            className={`col-12 d-md-block p-0 ${
                                chatMob ? 'd-block' : 'd-none'
                            } ${
                                !toggle
                                    ? 'col-lg-9 col-md-8'
                                    : 'col-md chat-sidebar-expanded'
                            }`}
                        >
                            <ChatDetails
                                selectedChat={selectedChat}
                                setChatMob={setChatMob}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Chat;
